import { Intercom, trackEvent, update } from '@intercom/messenger-js-sdk'
import { useAdmin } from '@vtex/raccoon-next'
import { useAdminUser } from 'hooks'
import { useEffect } from 'react'

var APP_ID = process.env.NEXT_PUBLIC_INTERCOM_APPID ?? ''

Intercom({
  app_id: APP_ID,
})

export function useIntercom() {
  const { data: user } = useAdminUser()
  const { account } = useAdmin()

  useEffect(() => {
    user &&
      update({
        email: user.email,
        user_id: user.id,
        account,
      })
  }, [user, account])

  function trackIntercomEvent(event: string, metadata: Record<string, any>) {
    const shouldTrack = !!APP_ID && user?.internalUser === false

    shouldTrack && trackEvent(event, metadata)
  }

  return { trackIntercomEvent }
}
